import _ from 'lodash';
import {
    FETCH_RAINPRO_STORAGE_LOGS,
    CLEAN_RAINPRO_STORAGE_LOGS,
} from './types';
import {request, __} from '../functions';

export const fetchRainproStorageLogs = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/rainpro/storage-logs/${screen.props.params.id}`, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_RAINPRO_STORAGE_LOGS, payload: data });
    });
};

export const cleanRainproStorageLogs = () => ({ type: CLEAN_RAINPRO_STORAGE_LOGS });
